import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Checkbox } from "@mui/material";
import { DayPicker } from "react-day-picker";
import { ko } from "date-fns/locale";
import "react-day-picker/dist/style.css";

import { useNavigate } from "react-router-dom";
import { X } from "lucide-react"; // 또는 다른 아이콘 패키지
import axios from "axios";
import Delete from "../../../assets/image/auto/delete_icon.png"


const AutoMarketingUpdate = () => {
    const navigate = useNavigate(); // ✅ useNavigate 훅 사용
    const popupRef = useRef();
    const returnHome = () => {
        navigate(-1); // ✅ 이전 페이지로 이동
    };

    const location = useLocation();
    const { item } = location.state;
    const [repeat, setRepeat] = useState(() => {
        if (item.tags.includes("매일 포스팅")) return "매일";
        if (item.tags.some((tag) => tag.includes("~"))) return "매주";
        return "없음";
    });

    const [channel, title, age, style] = item.tags.slice(0, 4);
    const [popupMessage, setPopupMessage] = useState(null); // "수정 완료", "삭제 완료"
    const [showConfirm, setShowConfirm] = useState(false); // 삭제 확인 여부

    const [selectedTime, setSelectedTime] = useState(item.uploadTime);
    const [notifyBeforeUpload, setNotifyBeforeUpload] = useState(!!item.alertCheck);

    const [startDate, setStartDate] = useState(() => {
        const dateRange = item.tags?.[4]; // 예: "2025-06-19~2025-07-01"
        if (dateRange?.includes("~")) {
            const [start,] = dateRange.split("~").map(s => s.trim());
            return new Date(start);
        }
        return new Date();
    });

    const [endDate, setEndDate] = useState(() => {
        const dateRange = item.tags?.[4]; // 예: "2025-06-19~2025-07-01"
        if (dateRange?.includes("~")) {
            const [, end] = dateRange.split("~").map(s => s.trim());
            return new Date(end);
        }
        return new Date();
    });

    useEffect(() => {
        if (popupMessage && popupRef.current) {
            popupRef.current.focus();
        }
    }, [popupMessage]);


    const handleRepeatChange = (type) => setRepeat(type);
    const [dateOpen, setDateOpen] = useState(false);
    const [selectStep, setSelectStep] = useState(0);

    // 수정 로직
    const handleUpdate = async () => {
        const updatedData = {
            user_id: localStorage.getItem("user_id"),
            start_date: startDate.toISOString().split('T')[0],
            end_date: endDate.toISOString().split('T')[0],
            repeat_time: repeat,
            alert_check: notifyBeforeUpload,
            user_record_id: item.id,
        };
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/update/user/reco`,
                updatedData,
                { headers: { "Content-Type": "application/json" } }
            );
            const result = response.data;
            if (result.success) {
                setPopupMessage("수정되었습니다.");
            } else {
                setPopupMessage("업데이트에 실패했습니다. 다시 시도해주세요.");
            }
        } catch (error) {
            console.error("자동화 광고 업데이트 중 오류:", error);
            setPopupMessage("서버 오류가 발생했습니다. 다시 시도해주세요.");
        }
    };


    // 삭제 로직
    const confirmDelete = async () => {
        setShowConfirm(false);
        const updatedData = {
            user_id: localStorage.getItem("user_id"),
            user_record_id: item.id,
        };
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/auto/delete/user/reco`,
                updatedData,
                { headers: { "Content-Type": "application/json" } }
            );
            const result = response.data;
            if (result.success) {
                setPopupMessage("삭제되었습니다.");
                navigate(-1)
            } else {
                setPopupMessage("삭제에 실패했습니다. 다시 시도해주세요.");
            }
        } catch (error) {
            console.error("삭제 오류:", error);
            setPopupMessage("서버 오류가 발생했습니다.");
        }
    };



    return (
        <div className="p-4">
            <div className="flex justify-between items-center pb-4">
                <button onClick={returnHome}>
                    <X className="w-6 h-6 text-gray-600" /> {/* ✅ React 아이콘 */}
                </button>
                <h2 className="text-lg font-semibold">AI 홍보 이미지 생성</h2>
                <span className="w-6" /> {/* 타이틀 가운데 정렬 위한 placeholder */}
            </div>

            <div className="w-full pb-4">
                <img
                    src={item.src}
                    alt="preview"
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="flex flex-row gap-4 items-center justify-center pb-4 whitespace-nowrap">
                <div className="bg bg-gray-300 px-2 py-2 rounded-lg w-full text-center">
                    {channel}
                </div>
                <div className="bg bg-gray-300 px-2 py-2 rounded-lg w-full text-center">
                    {title}
                </div>
                <div className="bg bg-gray-300 px-2 py-2 rounded-lg w-full text-center">
                    {age}
                </div>
                <div className="bg bg-gray-300 px-2 py-2 rounded-lg w-full text-center">
                    {style}
                </div>
            </div>


            <div className="pb-4">
                <div className="font-semibold pb-2">반복여부</div>
                <div className="grid grid-cols-4">
                    {['없음', '매일', '매주', '매월'].map((type) => (
                        <button
                            key={type}
                            onClick={() => handleRepeatChange(type)}
                            className={`py-2 border  ${repeat === type ? 'border-purple-500 text-purple-500' : 'border-gray-300 text-gray-500'}`}
                        >
                            {type}
                        </button>
                    ))}
                </div>
            </div>
            {/* 기간 선택 */}
            <div className="pb-6">
                <label className="block font-semibold text-base">날짜선택</label>

                <div
                    className="w-full border-b border-gray-300 py-3 cursor-pointer text-lg text-gray-700 flex justify-between items-center"
                    onClick={() => setDateOpen(!dateOpen)}
                >
                    {startDate ? (
                        repeat === "없음" ? (
                            <span>{startDate.toLocaleDateString()}</span>
                        ) : endDate ? (
                            <span>{`${startDate.toLocaleDateString()} ~ ${endDate.toLocaleDateString()}`}</span>
                        ) : (
                            <span className="text-gray-400">업로드할 날짜를 선택해 주세요.</span>
                        )
                    ) : (
                        <span className="text-gray-400">업로드할 날짜를 선택해 주세요.</span>
                    )}
                    <svg
                        className="w-5 h-5 text-gray-400 pl-2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>

                {dateOpen && (
                    <div className="pt-4">
                        <DayPicker
                            mode={repeat === "없음" ? "single" : "range"}
                            selected={repeat === "없음" ? startDate : { from: startDate, to: endDate }}
                            onSelect={(range) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);

                                if (repeat === "없음") {
                                    if (range && range >= today) {
                                        setStartDate(range);
                                        setEndDate(range);
                                        setDateOpen(false);
                                    }
                                } else {
                                    const from = range?.from ?? null;
                                    const to = range?.to ?? null;
                                    setStartDate(from);
                                    setEndDate(to);

                                    if (selectStep === 0 && from) {
                                        setSelectStep(1);
                                    } else if (selectStep === 1 && to) {
                                        setDateOpen(false);
                                        setSelectStep(0);
                                    }
                                }
                            }}
                            locale={ko}
                            numberOfMonths={1}
                            disabled={(date) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);

                                if (repeat === "없음") {
                                    return date < today;
                                }

                                if (selectStep === 0) {
                                    // 시작일 선택 시: 오늘 이전 비활성화
                                    return date < today;
                                }

                                if (selectStep === 1) {
                                    // 종료일 선택 시: 시작일 이전 비활성화
                                    return date < startDate;
                                }

                                return false;
                            }}

                        />
                    </div>
                )}
            </div>


            <div className="pb-2">
                <div className="font-semibold pb-2">시간선택</div>
                <input
                    type="time"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    className="border px-3 py-2 rounded-md w-full text-sm"
                />
            </div>

            <div className="flex items-center pb-2">
                <Checkbox
                    checked={!!notifyBeforeUpload}
                    onChange={(e) => setNotifyBeforeUpload(e.target.checked)}
                    sx={{ color: "#654AEF", '&.Mui-checked': { color: "#654AEF" } }}
                />
                <span className="text-sm">업로드 전 알림을 받고 이미지를 확인하고 싶어요!</span>
            </div>

            <div className="flex justify-between gap-2">
                <button className="flex-[2] py-3 rounded-md bg-gray-400 text-white" onClick={returnHome}>취소</button>

                <button className="flex-[3] py-3 rounded-md bg-red-600 text-white flex items-center justify-center gap-1" onClick={() => setShowConfirm(true)}>
                    삭제
                    <img src={Delete} alt="삭제" className="w-4 h-4" />
                </button>

                <button className="flex-[5] py-3 rounded-md bg-[#654AEF] text-white" onClick={handleUpdate}>수정</button>
            </div>

            {/* 결과 팝업 */}
            {popupMessage && (
                <div
                    ref={popupRef}
                    tabIndex={0}
                    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
                    onKeyDown={(e) => e.key === "Enter" && setPopupMessage(null)}
                >
                    <div className="bg-white p-6 rounded-md shadow-md text-center">
                        <p className="text-lg font-semibold">{popupMessage}</p>
                        <button className=" px-4 py-2 bg-[#654AEF] text-white rounded" onClick={() => setPopupMessage(null)}>
                            확인
                        </button>
                    </div>
                </div>
            )}


            {/* 삭제 확인 팝업 */}
            {showConfirm && (
                <div
                    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
                    onClick={() => setShowConfirm(false)}
                    onKeyDown={(e) => e.key === "Enter" && confirmDelete()}
                    tabIndex={0}
                >
                    <div className="bg-white p-6 rounded-md shadow-md text-center">
                        <p className="text-lg font-semibold">정말로 삭제하시겠습니까?</p>
                        <div className="pt-4 flex justify-center gap-4">
                            <button className="px-4 py-2 bg-gray-400 text-white rounded" onClick={() => setShowConfirm(false)}>취소</button>
                            <button className="px-4 py-2 bg-red-600 text-white rounded" onClick={confirmDelete}>삭제</button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default AutoMarketingUpdate;
